<template>
  <div class="py-4 container-fluid">
    <!-- RINGKASAN -->
    <div class="row">
      <div class="col-lg-4 col-md-6 mb-3">
        <div class="card" style="cursor: pointer;" @click="filterStatus('')">
          <div class="card-body p-3">
            <p class="text-sm mb-1 text-uppercase font-weight-bold">Termin Belum Lunas</p>
            <h5 class="font-weight-bolder mb-0">{{ totUnpaid }}</h5>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-3">
        <div class="card" style="cursor: pointer;" @click="filterStatus('Overdue')">
          <div class="card-body p-3">
            <p class="text-sm mb-1 text-uppercase font-weight-bold">Lewat Jatuh Tempo</p>
            <h5 class="font-weight-bolder text-danger mb-0">{{ totOverdue }}</h5>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-3">
        <div class="card">
          <div class="card-body p-3">
            <p class="text-sm mb-1 text-uppercase font-weight-bold">Jatuh Tempo 7 Hari ke Depan</p>
            <h5 class="font-weight-bolder text-warning mb-0">{{ totDueWeek }}</h5>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="row">
            <div class="col-lg-4">
              <div class="card-header pb-0">
                <h6>Jadwal Pembayaran (Termin PO)</h6>
                <p class="text-xs mb-0">Jatuh tempo = tanggal PO + periode termin. Nilai termin = % x total PO (incl. PPN).</p>
              </div>
            </div>
            <div class="col-lg-5">
              <input type="text" class="form-control mt-3" placeholder="Search by PO No." v-model="search.po_no" v-on:keyup.enter="quickSearch()">
            </div>
            <div class="col-lg-3">
              <argon-button style="margin-left: 60px;" class="mt-4" variant="gradient" color="secondary" size="sm" @click="formFilter.show = true"><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2 mt-4">
            <div class="table-responsive p-0 scroll">
              <table class="table table-striped align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Jatuh Tempo</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">PO No.</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Vendor</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Termin</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">%</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Nilai Termin</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Dibayar</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Sisa</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Status</th>
                    <th class="text-secondary"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in table.data" :key="i">
                    <td class="align-middle text-center">
                      <span :class="row.is_overdue ? 'text-danger text-xs font-weight-bolder' : 'text-secondary text-xs font-weight-bold'" v-if="row.date_payment">{{ moment(row.date_payment).locale('id').format('LL') }}</span>
                      <span class="badge badge-sm bg-gradient-danger ms-1" v-if="row.is_overdue">Overdue</span>
                    </td>
                    <td class="align-middle text-center"><span class="badge badge-sm bg-gradient-primary">{{ row.po_no }}</span></td>
                    <td class="align-middle text-center"><span class="text-secondary text-xs font-weight-bold">{{ row.company_name }}</span></td>
                    <td class="align-middle text-center"><span class="text-secondary text-xs font-weight-bold">{{ row.term_payment }}</span></td>
                    <td class="align-middle text-center"><span class="text-secondary text-xs font-weight-bold">{{ row.percentage }}%</span></td>
                    <td class="align-middle text-end"><span class="text-secondary text-xs font-weight-bold">{{ fmt(row.term_amount, row.currency) }}</span></td>
                    <td class="align-middle text-end"><span class="text-secondary text-xs font-weight-bold">{{ fmt(row.amount_paid, row.currency) }}</span></td>
                    <td class="align-middle text-end"><span class="text-danger text-xs font-weight-bold">{{ row.status == 'Paid' ? fmt(0, row.currency) : fmt(row.remaining, row.currency) }}</span></td>
                    <td class="align-middle text-center">
                      <span class="badge badge-sm bg-gradient-success" v-if="row.status == 'Paid'">Paid</span>
                      <span class="badge badge-sm bg-gradient-warning" v-else-if="row.status == 'Partially Paid'">Partially Paid</span>
                      <span class="badge badge-sm bg-gradient-secondary" v-else>Not Yet Paid</span>
                    </td>
                    <td>
                      <i class="fa fa-money fa-sm" aria-hidden="true" title="Catat pembayaran termin ini" style="cursor: pointer; margin-right: 20px;" @click="openPay(row)" v-if="row.status != 'Paid' && row.remaining > 0"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card-footer">
            <div class="float-left">TOTAL ROWS : {{ table.data.length }}</div>
            <div class="float-right">
              <base-pagination :page-count="pagination.page_count" :value="pagination.page" @input="changePage" :total="pagination.page_count" class="justify-content-end"></base-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL BAYAR TERMIN ======= -->
  <div class="container">
    <vue-final-modal v-model="formPay.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <div class="row">
        <div class="col-11 float-left"><span class="modal__title">Bayar Termin {{ pay.po_no }}</span></div>
        <div class="col-1 float-right"><i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formPay.show = false"></i></div>
      </div><hr>
      <div class="modal__content container">
        <p class="text-sm mb-1">{{ pay.company_name }} &mdash; {{ pay.term_payment }} ({{ pay.percentage }}%)</p>
        <p class="text-sm mb-2">Sisa termin: <b>{{ fmt(pay.remaining, pay.currency) }}</b></p>
        <div class="bank-box" v-if="pay.bank_account_no">
          <i class="fas fa-university"></i> Transfer ke: <b>{{ pay.bank_name }} {{ pay.bank_branch }}</b> &middot; <b>{{ pay.bank_account_no }}</b>
          <span v-if="pay.bank_account_name"> a.n. {{ pay.bank_account_name }}</span>
        </div>
        <div class="bank-box bank-empty" v-else><i class="fas fa-exclamation-triangle"></i> Rekening bank vendor belum diisi di Vendor Management</div>
        <label class="form-control-label mt-2">Jumlah Dibayar ({{ pay.currency }}) <span style="color: red;">*</span></label>
        <input type="number" step="0.01" class="form-control" v-model="pay.payment_amount">
        <small class="text-xs">Boleh kurang dari sisa termin (dicicil).</small><br>
        <label class="form-control-label mt-2">Tanggal Bayar <span style="color: red;">*</span></label>
        <input type="date" class="form-control" v-model="pay.payment_date">
        <label class="form-control-label mt-2">Metode</label>
        <select class="form-select" v-model="pay.payment_method">
          <option v-for="(m, i) in paymentMethods" :key="i" :value="m">{{ m }}</option>
        </select>
        <label class="form-control-label mt-2">No. Referensi / Bukti Transfer</label>
        <input type="text" class="form-control" v-model="pay.reference_no">
        <label class="form-control-label mt-2">Catatan</label>
        <textarea class="form-control" v-model="pay.note"></textarea>
      </div>
      <div class="row float-right mt-3">
        <div class="col-6"></div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button variant="gradient" color="secondary" size="sm" width="1" @click="formPay.show = false">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="savePay()" :disabled="onLoading">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>Bayar</span>
          </argon-button>
        </div>
      </div>
    </vue-final-modal>
  </div>

  <!-- =======  MODAL FILTER ======= -->
  <div class="container">
    <vue-final-modal v-model="formFilter.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <div class="row">
        <div class="col-11 float-left"><span class="modal__title">Filter</span></div>
        <div class="col-1 float-right"><i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilter.show = false"></i></div>
      </div><hr>
      <div class="modal__content container">
        <label class="form-control-label mt-3">Status</label>
        <select class="form-select" v-model="search.status">
          <option value="">All</option>
          <option value="Not Yet Paid">Not Yet Paid</option>
          <option value="Partially Paid">Partially Paid</option>
          <option value="Paid">Paid</option>
          <option value="Overdue">Overdue</option>
        </select>
        <label class="form-control-label mt-3">Vendor</label>
        <input type="text" class="form-control" placeholder="Nama Vendor" v-model="search.vendor_name">
        <label class="form-control-label mt-3">Jatuh Tempo</label>
        <flat-pickr :config="{ mode: 'range',}" class="form-control" v-model="search.date_payment"/>
      </div>
      <div class="row float-right mt-3">
        <div class="col-6"></div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button variant="gradient" color="secondary" size="sm" width="1" @click="search = {po_no: '', vendor_name: '', status: '', date_payment: ''}">Clear</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="quickSearch()">Filter</argon-button>
        </div>
      </div>
    </vue-final-modal>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import BasePagination from "@/components/BasePagination";
import Api from '@/helpers/api';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
var moment = require('moment');
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import accounting from '@/services/accounting/accounting.service';

export default {
  name: "AccPaymentSchedule",
  components: {
    ArgonButton,
    VueFinalModal,
    BasePagination,
    flatPickr,
  },
  data() {
    return {
      moment: moment,
      pagination: { page_count: '', page: 1 },
      table: { data: [] },
      totUnpaid: 0,
      totOverdue: 0,
      totDueWeek: 0,
      formFilter: { show: false },
      formPay: { show: false },
      pay: {},
      paymentMethods: ['Transfer', 'Cash', 'Giro', 'Cek'],
      onLoading: false,
      search: { po_no: '', vendor_name: '', status: '', date_payment: '' },
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    fmt(value, currency) {
      return (currency || 'IDR')+' '+Number(value || 0).toLocaleString('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    get() {
      let context = this;
      Api(context, accounting.paymentSchedule({ po_no: context.search.po_no, vendor_name: context.search.vendor_name, status: context.search.status, date_payment: context.search.date_payment, page: context.pagination.page })).onSuccess(function(response) {
          context.table.data            = response.data.data.data.data;
          context.pagination.page_count = response.data.data.data.last_page;
          context.totUnpaid             = response.data.data.totUnpaid;
          context.totOverdue            = response.data.data.totOverdue;
          context.totDueWeek            = response.data.data.totDueWeek;
      }).onError(function() {
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() {
          context.formFilter.show = false;
      })
      .call()
    },
    quickSearch() {
      this.pagination.page = 1;
      this.get();
    },
    filterStatus(status) {
      this.search.status = status;
      this.quickSearch();
    },
    openPay(row) {
      this.pay = {
        id:             row.id,
        po_no:          row.po_no,
        company_name:   row.company_name,
        bank_name:         row.bank_name,
        bank_branch:       row.bank_branch,
        bank_account_no:   row.bank_account_no,
        bank_account_name: row.bank_account_name,
        term_payment:   row.term_payment,
        percentage:     row.percentage,
        currency:       row.currency,
        remaining:      row.remaining,
        payment_amount: row.remaining,
        payment_date:   moment().format('YYYY-MM-DD'),
        payment_method: 'Transfer',
        reference_no:   '',
        note:           '',
      };
      this.formPay.show = true;
    },
    savePay() {
      let context = this;
      if (!(Number(context.pay.payment_amount) > 0) || !context.pay.payment_date) {
        return alert('Jumlah dan Tanggal Bayar wajib diisi');
      }
      if (Number(context.pay.payment_amount) > Number(context.pay.remaining) + 0.01) {
        return alert('Jumlah melebihi sisa termin');
      }
      context.onLoading = true;
      Api(context, accounting.payTerm(context.pay.id, {
        payment_amount: context.pay.payment_amount,
        payment_date:   context.pay.payment_date,
        payment_method: context.pay.payment_method,
        reference_no:   context.pay.reference_no,
        note:           context.pay.note,
      })).onSuccess(function() {
          context.formPay.show = false;
          context.notify('Pembayaran Berhasil Dicatat', 'success')
          context.get();
      }).onError(function(error) {
          context.notify((error.response && error.response.data.message) ? error.response.data.message : 'Pembayaran Gagal Dicatat', 'error')
      }).onFinish(function() {
          context.onLoading = false;
      })
      .call();
    },
    changePage(page) {
      this.pagination.page = page;
      this.get();
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT, autoClose: 2000 });
      } else {
        toast.error(message, { position: toast.POSITION.BOTTOM_RIGHT, autoClose: 3000 });
      }
    },
  }
};
</script>

<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
.scroll {
  overflow: auto;
  height: 600px;
}
.scroll thead th {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #F0F8FF;
}

.bank-box { font-size: 0.8rem; background: #eef6ff; border: 1px solid #cfe3ff; border-radius: 8px; padding: 8px 12px; margin-bottom: 12px; color: #344767; }
.bank-box i { color: #5e72e4; margin-right: 4px; }
.bank-empty { background: #fff8e6; border-color: #ffe2a8; color: #8a6100; }
.bank-empty i { color: #e0a100; }
</style>
